<section class="w-full  py-14 md:py-20" [appScrollSection]="data?.anker">
  <div class="max-w-6xl mx-auto px-6">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 items-stretch">
      <ng-container *ngFor="let tile of data?.tiles">
        <jnguyen-tile-membership [data]="tile.fields"></jnguyen-tile-membership>
      </ng-container>
    </div>
  </div>
</section>
